import { Nullable } from 'clickNgo/models/utils'
import { QBR_DOCUMENT_URL_PID } from 'partner360/components/QBR/configs'

export const isShowSelectPartnersModalDialog = (
  path: string,
  documentEntryId: Nullable<number>
) => {
  if (path.includes(QBR_DOCUMENT_URL_PID)) {
    return false
  }
  return documentEntryId === null
}
